import { drawLaplacianMesh } from "./laplacianTrain";
import { getBufferGeometry, rotatePoint3D, rotatePoint3DArr } from "./geometry";
import * as THREE from "three";
import * as BufferGeometryUtils from "three/addons/utils/BufferGeometryUtils.js";
import { smoothGeometry } from "./legacy";

let initModuleFunc = null;
let prepareDeformFunc = null;
let doDeformFunc = null;
let freeModuleFunc = null;
let moduleInitialised = false;

function ldLoadCallback(initModule, prepareDeform, doDeform, freeModule) {
  console.log("ldLoadCallback success");
  initModuleFunc = initModule;
  prepareDeformFunc = prepareDeform;
  doDeformFunc = doDeform;
  freeModuleFunc = freeModule;
  // drawLaplacianMesh();
}

function getFacesObj(geometry) {
  const index = geometry.index;
  const position = geometry.getAttribute("position");
  const positionArr = position.array;

  const positions = [];
  const cells = [];
  if (index) {
    const indexArr = index.array;
    for (let i = 0; i < indexArr.length; i += 3) {
      cells.push([indexArr[i], indexArr[i + 1], indexArr[i + 2]]);
    }
  }

  for (let i = 0, j = 0; i < positionArr.length; i += 3, j++) {
    positions.push([positionArr[i], positionArr[i + 1], positionArr[i + 2]]);
    if (!index && j % 3 == 0) {
      cells.push([j, j + 1, j + 2]);
    }
  }

  const faceObj = { cells: cells, positions: positions };
  faceObj.savedPositions = JSON.parse(JSON.stringify(faceObj.positions));
  faceObj.savedVectors = faceObj.savedPositions.map(p => new THREE.Vector3(p[0], p[1], p[2]));

  return faceObj;
}

function setLaplacianMesh(crossedMesh, toothBox, diff) {
  if (moduleInitialised) {
    freeModuleFunc();
    moduleInitialised = false;
  }

  let laplacianMesh = crossedMesh.laplacianMesh;

  if (!laplacianMesh) {
    let geometry = crossedMesh.geometry;
    if (!geometry.index) {
      let cloneGeometry = crossedMesh.geometry.clone();
      cloneGeometry.deleteAttribute("normal");
      cloneGeometry.deleteAttribute("uv");
      cloneGeometry = BufferGeometryUtils.mergeVertices(cloneGeometry);
      cloneGeometry.computeVertexNormals();
      cloneGeometry.computeBoundingBox();
      // crossedMesh.geometry.dispose();
      // crossedMesh.geometry = cloneGeometry;
      geometry = cloneGeometry;
    }

    laplacianMesh = getFacesObj(geometry);
    laplacianMesh.colors = [];

    laplacianMesh.unconstrained = [];
    laplacianMesh.staticHandles = [];
    laplacianMesh.movedHandles = [];

    const position = geometry.getAttribute("position");
    const index = geometry.index;
    console.log("index", index);

    const positionArr = position.array;
    let innerBox = new THREE.Box3(
      new THREE.Vector3(toothBox.min.x, toothBox.min.y, toothBox.min.z),
      new THREE.Vector3(toothBox.max.x, toothBox.max.y, toothBox.max.z)
    );
    let outerBox = new THREE.Box3(
      new THREE.Vector3(
        toothBox.min.x - diff,
        toothBox.min.y,
        toothBox.min.z - diff
      ),
      new THREE.Vector3(
        toothBox.max.x + diff,
        toothBox.max.y,
        toothBox.max.z + diff
      )
    );

    const colorArr = [];
    for (let i = 0, j = 0; i < positionArr.length; i += 3, j++) {
      let pos = new THREE.Vector3(
        positionArr[i],
        positionArr[i + 1],
        positionArr[i + 2]
      );
      if (outerBox.containsPoint(pos)) {
        if (innerBox.containsPoint(pos) && pos.y < toothBox.center.y) {
          laplacianMesh.movedHandles.push(j);
          // colorArr.push(1, 0, 0);
        } else {
          laplacianMesh.unconstrained.push(j);
          // colorArr.push(0, 1, 0);
        }
      } else {
        laplacianMesh.staticHandles.push(j);
        // colorArr.push(0, 0, 1);
      }
      colorArr.push(1, 0.71, 0.76);
    }
    const colors = new Float32Array(colorArr);
    geometry.setAttribute("color", new THREE.BufferAttribute(colors, 3));

    laplacianMesh.allHandles = laplacianMesh.movedHandles.concat(
      laplacianMesh.staticHandles
    );
    crossedMesh.laplacianMesh = laplacianMesh;
  }

  let startTime = window.performance.now();
  initModuleFunc(laplacianMesh);
  prepareDeformFunc(laplacianMesh.allHandles, laplacianMesh.unconstrained);
  moduleInitialised = true;
  let deltaTime = window.performance.now() - startTime;
  console.log(
    `prepareDeformFunc time ${deltaTime.toFixed(3)}ms\n`,
    laplacianMesh
  );

  // doLaplacianMove(crossedMesh, [0, 0, 0]);
}

function doLaplacianMove(crossedMesh, offset) {
  if (crossedMesh && crossedMesh.laplacianMesh) {
    let laplacianMesh = crossedMesh.laplacianMesh;
    var handlesPositionsArr = [];
    for (const mvHandle of laplacianMesh.movedHandles) {
      handlesPositionsArr.push([
        laplacianMesh.positions[mvHandle][0] + offset[0],
        laplacianMesh.positions[mvHandle][1] + offset[1],
        laplacianMesh.positions[mvHandle][2] + offset[2],
      ]);
    }
    for (const stHandle of laplacianMesh.staticHandles) {
      handlesPositionsArr.push([
        laplacianMesh.positions[stHandle][0],
        laplacianMesh.positions[stHandle][1],
        laplacianMesh.positions[stHandle][2],
      ]);
    }

    var result = doDeformFunc(handlesPositionsArr);
    applyLaplacianResult(crossedMesh, result);
  }
}

function doLaplacianRotate(crossedMesh, center, angleX, angleY, angleZ) {
  if (crossedMesh && crossedMesh.laplacianMesh) {
    let laplacianMesh = crossedMesh.laplacianMesh;
    var handlesPositionsArr = [];
    for (const mvHandle of laplacianMesh.movedHandles) {
      let point = laplacianMesh.positions[mvHandle];
      let rotated = rotatePoint3DArr(center, angleX, angleY, angleZ, point);
      handlesPositionsArr.push([rotated.x, rotated.y, rotated.z]);
      // handlesPositionsArr.push([
      //   laplacianMesh.positions[mvHandle][0] + offset[0],
      //   laplacianMesh.positions[mvHandle][1] + offset[1],
      //   laplacianMesh.positions[mvHandle][2] + offset[2],
      // ]);
    }
    for (const stHandle of laplacianMesh.staticHandles) {
      handlesPositionsArr.push([
        laplacianMesh.positions[stHandle][0],
        laplacianMesh.positions[stHandle][1],
        laplacianMesh.positions[stHandle][2],
      ]);
    }

    var result = doDeformFunc(handlesPositionsArr);
    applyLaplacianResult(crossedMesh, result);
  }
}

function applyLaplacianResult(crossedMesh, result) {
  let oldGeometry = crossedMesh.geometry;
  let laplacianMesh = crossedMesh.laplacianMesh;
  let unconstrained = laplacianMesh.unconstrained;
  // for (const i of unconstrained) {
  //   laplacianMesh.positions[i] = result[i];
  // }

  for (var i = 0; i < laplacianMesh.positions.length; i++) {
    laplacianMesh.positions[i] = result[i];
  }

  const newGeometry = new THREE.BufferGeometry();
  const vertArr = [];
  laplacianMesh.positions.forEach((pos) => {
    vertArr.push(...pos);
  });
  const vertices = new Float32Array(vertArr);
  newGeometry.setAttribute("position", new THREE.BufferAttribute(vertices, 3));

  const indices = [];
  laplacianMesh.cells.forEach((cell) => {
    indices.push(...cell);
  });
  newGeometry.setIndex(indices);

  let colorAttr = oldGeometry.getAttribute("color");
  if (colorAttr) {
    newGeometry.setAttribute("color", colorAttr.clone());
  }

  oldGeometry.dispose();
  crossedMesh.geometry = smoothGeometry(newGeometry);
}

export {
  ldLoadCallback,
  initModuleFunc,
  prepareDeformFunc,
  doDeformFunc,
  freeModuleFunc,
  setLaplacianMesh, // as prepareCrossedMesh,
  getFacesObj,
  doLaplacianMove,
  doLaplacianRotate,
};
